import React, { useEffect, useState } from "react";
import { PageHero, FadeUp } from "../../components/public/Section";
import { api, mediaUrl } from "../../lib/api";

function groupByDesignation(members) {
  return members.reduce((acc, member) => {
    const key = member.designation || "Member";
    acc[key] = acc[key] || [];
    acc[key].push(member);
    return acc;
  }, {});
}

export default function ExecutiveCommittee() {
  const [sections, setSections] = useState([]);
  useEffect(() => { api.get("/organization").then((r) => setSections(r.data?.sections || [])); }, []);
  const officeBearers = sections.find((section) => section.name === "Office Bearers");
  const committees = sections.filter((section) => section.name !== "Office Bearers" && section.members?.length);

  return (
    <div>
      <PageHero title="Organization Structure" subtitle="Office bearers and committees guiding the Society's academic and administrative activities." breadcrumbs={["Home", "Organization Structure"]} />
      <section className="section container-page">
        {officeBearers?.members?.length ? (
          <div className="mb-16">
            <div className="eyebrow mb-4"><span className="eyebrow-line" />{officeBearers.name}</div>
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-7">
              {officeBearers.members.map((c, i) => (
                <FadeUp key={c.id} delay={i * 0.03} className="card-elev p-7 text-center">
                  <img src={mediaUrl(c.photo)} alt={c.name} className="w-32 h-32 md:w-36 md:h-36 rounded-full object-cover mx-auto ring-4 ring-brand-primary-light shadow-[0_20px_45px_-25px_rgba(0,86,166,0.45)]" />
                  <div className="text-xs text-brand-primary font-semibold uppercase tracking-wider mt-6">{c.designation}</div>
                  <div className="font-serif font-bold text-brand-text text-xl mt-2">{c.name}</div>
                </FadeUp>
              ))}
            </div>
          </div>
        ) : null}

        <div className="space-y-12">
          {committees.map((section) => {
            const grouped = groupByDesignation(section.members || []);
            return (
              <FadeUp key={section.id} className="card-elev p-6 md:p-8">
                <div className="flex items-end justify-between gap-4 flex-wrap mb-6">
                  <div>
                    <div className="eyebrow mb-2"><span className="eyebrow-line" />Committee</div>
                    <h2 className="font-serif text-2xl font-bold text-brand-text">{section.name}</h2>
                  </div>
                  <div className="text-sm text-brand-muted">{section.members.length} members</div>
                </div>
                <div className="space-y-7">
                  {Object.entries(grouped).map(([designation, members]) => (
                    <div key={designation}>
                      <h3 className="text-xs text-brand-primary font-semibold uppercase tracking-wider mb-3">{members.length > 1 && designation === "Member" ? "Members" : designation}</h3>
                      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                        {members.map((c) => (
                          <div key={c.id} className="rounded-xl border border-brand-border bg-white p-4 flex items-center gap-4">
                            <img src={mediaUrl(c.photo)} alt={c.name} className="w-16 h-16 rounded-full object-cover ring-2 ring-brand-primary-light shrink-0" />
                            <div className="min-w-0">
                              <div className="font-serif font-bold text-brand-text truncate">{c.name}</div>
                              <div className="text-xs text-brand-muted mt-1">{c.designation}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </FadeUp>
            );
          })}
          {sections.length === 0 && <div className="text-center text-brand-muted py-16">No organization structure to display.</div>}
        </div>
      </section>
    </div>
  );
}
